var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"log-view"},[_c('pre',[_c('code',[_vm._v(_vm._s(_vm.log))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }